import paths from "~/constants/paths";

import {
  Tenant,
  TenantRefreshResponse,
  TenantResponse,
} from "~/types/Data/Common/tenant";

export default function useTenant() {
  const tenant = useCookie<Tenant | undefined>("tenant");

  const loading = ref(false);
  const errorMessage = ref<string>();
  const runtimeConfigs = useRuntimeConfig();
  const tenantUrl = runtimeConfigs?.public?.LANDLORD_URL;

  const login = async (data: any) => {
    tenant.value = undefined;
    errorMessage.value = undefined;
    loading.value = true;

    const { res, err } = await useApi<TenantResponse>(
      "/api/v1/tenant-builder/login",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: {
          email: data.email,
          password: data.password,
        },
      },
      {
        baseUrl: tenantUrl,
        catchError: true,
      },
    );

    if (err) {
      errorMessage.value =
        err.meta.errors?.[0].message ?? "Failed to auth tenant";
    } else if (res?.data) {
      tenant.value = {
        ...res.data,
      };

      reloadNuxtApp({ path: paths.home, force: true });
    }

    loading.value = false;
  };

  const refresh = async () => {
    const { res } = await useApi<TenantRefreshResponse>(
      "/api/v1/auth/refresh",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: {
          refresh_token: tenant.value?.refresh_token,
        },
      },
      {
        baseUrl: tenantUrl,
        catchError: true,
      },
    );

    if (tenant.value && res?.data) {
      tenant.value = {
        ...tenant.value,
        ...res.data,
      };
    } else {
      tenant.value = undefined;
    }
  };

  return {
    tenant,
    loading,
    errorMessage,
    login,
    refresh,
  };
}
